import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt } from '@fortawesome/pro-solid-svg-icons/faExternalLinkAlt';

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button } from 'ui-components/components/button';
import messages from '../../../fulfillment-planner/labeled-row/messages';
import LabeledRow from '../../../fulfillment-planner/labeled-row';
import TrackingStatusIndicator from '../../../components/tracking-status-indicator/index';
import { emptyObject } from 'ui-components/default-props/empty';

import style from './style.module.less';

const TrackingInformation = ({ trackingInformation = emptyObject, showMdash = false, isLocalDelivery = false }) => {
  const { trackingNumber, url: trackingUrl, status } = trackingInformation || emptyObject;
  const messageDescriptor = isLocalDelivery ? messages.tracking : messages.trackingNum;
  return (
    <LabeledRow className={style.row} label={<FormattedMessage {...messageDescriptor} />} labelClassName={style.label}>
      {showMdash && <span className={style.mdash}>&mdash;</span>}
      {!showMdash && (
        <span className={style.info}>
          {!isLocalDelivery && <TrackingStatusIndicator status={status} />}
          {trackingUrl ? (
            <Button className={style.link} href={trackingUrl} theme='link'>
              {!isLocalDelivery && trackingNumber}
              {isLocalDelivery && (
                <>
                  <FormattedMessage {...messages.trackOnUber} />
                  <FontAwesomeIcon className={style.icon} icon={faExternalLinkAlt} />
                </>
              )}
            </Button>
          ) : (
            trackingNumber
          )}
        </span>
      )}
    </LabeledRow>
  );
};

TrackingInformation.propTypes = {
  trackingInformation: PropTypes.object,
  showMdash: PropTypes.bool,
  isLocalDelivery: PropTypes.bool,
};

export default TrackingInformation;
